import {
  CLEAR_PLANNER,
  UPDATE_PLANNER,
  PLANNER_LINES,
  PLANNER_LINES_CLEAR,
  PLANNER_TASKS,
  PLANNER_TASKS_CLEAR,
  PLANNER_MEMOS,
  PLANNER_MEMOS_CLEAR,
  PLANNER_TASKABLES,
  PLANNER_TASKABLES_CLEAR,
  PLANNER_LOCATIONS,
  PLANNER_LOCATIONS_CLEAR,
  PLANNER_SCHEDULES,
  PLANNER_SCHEDULES_CLEAR,
  PLANNER_ORDERS,
  PLANNER_ORDERS_CLEAR
} from 'apps/action_types';
export const update = (payload: any) => {
  return {
    type: UPDATE_PLANNER,
    payload: payload,
  };
};
export const clear = () => {
  return {
    type: CLEAR_PLANNER,
    payload: {},
  };
};
export const lines = (payload: any) => {
  return {
    type: PLANNER_LINES,
    payload: payload,
  };
};
export const clear_lines = () => {
  return {
    type: PLANNER_LINES_CLEAR,
    payload: {},
  };
};
export const tasks = (payload: any) => {
  return {
    type: PLANNER_TASKS,
    payload: payload,
  };
};
export const clear_tasks = () => {
  return {
    type: PLANNER_TASKS_CLEAR,
    payload: {},
  };
};
export const memos = (payload: any) => {
  return {
    type: PLANNER_MEMOS,
    payload: payload,
  };
};
export const clear_memos = () => {
  return {
    type: PLANNER_MEMOS_CLEAR,
    payload: {},
  };
};
export const taskables = (payload: any) => {
  return {
    type: PLANNER_TASKABLES,
    payload: payload,
  };
};
export const clear_taskables = () => {
  return {
    type: PLANNER_TASKABLES_CLEAR,
    payload: {},
  };
};
export const locations = (payload: any) => {
  return {
    type: PLANNER_LOCATIONS,
    payload: payload,
  };
};
export const clear_locations = () => {
  return {
    type: PLANNER_LOCATIONS_CLEAR,
    payload: {},
  };
};
export const schedules = (payload: any) => {
  return {
    type: PLANNER_SCHEDULES,
    payload: payload,
  };
};
export const clear_schedules = () => {
  return {
    type: PLANNER_SCHEDULES_CLEAR,
    payload: {},
  };
};
export const orders = (payload: any) => {
  return {
    type: PLANNER_ORDERS,
    payload: payload,
  };
};
export const clear_orders = () => {
  return {
    type: PLANNER_ORDERS_CLEAR,
    payload: {},
  };
};

export const planner = {
  update:    update,
  clear:     clear,
  lines:     lines,
  tasks:     tasks,
  memos:     memos,
  taskables: taskables,
  locations: locations,
  schedules: schedules,
  orders:    orders,
  clear_lines:     clear_lines,
  clear_tasks:     clear_tasks,
  clear_memos:     clear_memos,
  clear_taskables: clear_taskables,
  clear_locations: clear_locations,
  clear_schedules: clear_schedules,
  clear_orders:    clear_orders
}

export const plannerAction = planner;
